import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { FormattedDate } from 'react-intl';
import Divider from 'material-ui/Divider';
import { CardText } from 'material-ui/Card';
import Markdown from 'react-markdown';

class CourseContentMain extends Component {

    render() {

        let displayDuration = '';
        const duration =  Number(this.props.course.duration) || 0;
        if (duration > 0) {
            const hours = Math.floor( duration / 60);
            const minutes = duration % 60;

            if (hours > 0) {
                displayDuration = hours + 'h';
                if (minutes > 0) {
                    displayDuration += ' ' + minutes + 'm';
                }
            } else if (minutes > 0) {
                displayDuration = minutes + 'm';
            }
        }

        let mainContent = [];
        if (this.props.course.validFrom) {
            const released = (<FormattedDate value={this.props.course.validFrom} year="numeric" month="long" day="numeric" />);
            mainContent.push(
                <div key="validFrom">
                    <h4>Released on <span>{released}</span></h4>
                    <p><em>{this.props.course.views} views</em></p>
                </div>
            );
        }

        if (!!this.props.course.description) {
            mainContent.push(
                <div key="description">
                    {this.props.course.description.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                </div>
            );
        }
        if (!!this.props.course.overview) {
            mainContent.push(
                <div key="overview">
                    <h4>Overview</h4>
                    {this.props.course.overview.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                </div>
            );
        }

        mainContent.push(
            <div key="category">
                <p><b>Category: </b>
                    <Link to={`/dashboard/library/${this.props.course.categoryId || "uncategorised"}`}>
                        {this.props.course.category || 'Uncategorised'}
                    </Link>
                </p>
            </div>
        );

        if (!!this.props.required && this.props.required > 0) {
            mainContent.push (
                <div key="required">
                    <h4>Criteria</h4>
                    <p>The required pass mark for this course is {this.props.required}%</p>
                </div>
            );
        }

        if (!!this.props.course.url) {
            mainContent.push(
                <div key="url">
                    <p><Link to={this.props.course.url} target="_blank">{this.props.course.url}</Link></p>
                </div>
            );
        }

        if (!!this.props.mediaContent) {
            mainContent.push(
                <div key="contentMedia">
                    <Divider />
                    <CardText>
                        <Markdown source={this.props.mediaContent} />
                    </CardText>
                    <CardText>
                        <p><Link to={`/dashboard/asset/${this.props.mediaId}`}>Details</Link></p>
                    </CardText>
                </div>
            );
        }
        let content = null;
        if (mainContent.length > 0) {
            content = (<div className="content-main" key="contentMain">{mainContent}</div>);
        }
        return content;
    }
}

CourseContentMain.propTypes = {
    course:     PropTypes.object.isRequired,
    assets:     PropTypes.arrayOf(PropTypes.object)
};

CourseContentMain.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseContentMain;

